/**
 * 组件的emit事件声明
 */
export const emits = [
  /** v-model 绑定值更新时触发 */
  'update:modelValue',
  /** 输入内容变化时触发 */
  'input',
  /** 输入框值变化且失焦时触发 */
  'change',
  /** 输入框获取焦点时触发 */
  'focus',
  /** 输入框失去焦点时触发 */
  'blur',
  /** 点击操作区时触发 */
  'action-click',
  /** 按下键盘按键时触发 */
  'keydown',
  /** 释放键盘按键时触发 */
  'keyup',
];

